var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.372 18.8504L17.3721 18.8505C17.5635 19.0401 17.8315 19.15 18.1096 19.15C18.7346 19.15 19.15 18.6689 19.15 18.1085C19.15 17.8374 19.0614 17.5789 18.8566 17.376L14.0981 12.6534C15.0728 11.4122 15.6457 9.86409 15.6457 8.17914C15.6457 4.14987 12.322 0.85 8.24787 0.85C4.18353 0.85 0.85 4.14013 0.85 8.17914C0.85 12.218 4.17383 15.5083 8.24787 15.5083C9.87225 15.5083 11.3677 14.9867 12.5897 14.1042L17.372 18.8504ZM8.24787 14.0133C5.01691 14.0133 2.36596 11.3766 2.36596 8.17914C2.36596 4.9913 5.01675 2.35443 8.24787 2.35443C11.479 2.35443 14.1298 4.9913 14.1298 8.17914C14.1298 11.3766 11.4788 14.0133 8.24787 14.0133Z",
    fill: "#252525",
    stroke: "#252525",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchBlack2);
export default __webpack_public_path__ + "static/media/ic_search_black_2.0eec082e55fadf9831a18e3020fae5d8.svg";
export { ForwardRef as ReactComponent };